import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n-bridge";
import LoadingSpinner from "@/components/atoms/LoadingSpinner.vue";
import ContestEntryFormContestAside from "@/components/organisms/event/ContestEntryFormContestAside.vue";
import { NolaPfContestClient } from "@/lib/clients";
import { NolaPfMicroCmsContest } from "@/lib/models/nolaPfContest";

type LoadState = "loading" | "loaded" | "error";


const __default__ = {
  metaInfo: {
    meta: [{ name: "robots", content: "none" }],
  },
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'EventContestEntryFormCompleted',
  props: {
    id: { type: String, required: false }
  },
  setup(__props: any) {

const props = __props as {
  id?: string;
};



const { t } = useI18n();
const nolaPfContestClient = new NolaPfContestClient();

const loadState = ref<LoadState>("loading");
const contest = ref<NolaPfMicroCmsContest | null>(null);

onMounted(async () => {
  const id = props.id;
  if (!id) {
    loadState.value = "error";
    return;
  }

  try {
    contest.value = await nolaPfContestClient.fetchMicroCmsContest(id);
    loadState.value = "loaded";
  } catch (error) {
    console.error("Failed to load contest entry completed page:", error);
    loadState.value = "error";
  }
});

return { __sfc: true,props, t, nolaPfContestClient, loadState, contest, LoadingSpinner, ContestEntryFormContestAside }
}

})